export default __webpack_public_path__ + "static/media/idea.1ab31484.png";